module.exports = __webpack_public_path__ + "static/media/pin.6a166f8f.svg";